// extracted by mini-css-extract-plugin
var _1 = "RentalPortalMatchChipsCell-moduleRentalPortalMatchChipsCell__pzlEY";
var _2 = "RentalPortalMatchChipsCell-modulechip__T_Jre Tag-moduleTag__FLr9H";
var _3 = "RentalPortalMatchChipsCell-modulecoverage__HA8qZ";
var _4 = "RentalPortalMatchChipsCell-modulerest__OgsuQ";
export { _1 as "RentalPortalMatchChipsCell", _2 as "chip", _3 as "coverage", _4 as "rest" }
